import { CardStyled } from "./card.styles";
import { Box, CardActions, CardContent, LinearProgress } from "@mui/material";
import Header from "../header/header";
import { Button } from "../../../../components/button/button";
import React, { ReactElement, Ref } from "react";

interface CardPropsType {
  content?: ReactElement;
  children?: JSX.Element;
  title: string;
  description?: string | JSX.Element;
  btnTitle?: string | JSX.Element;
  disabledConfirmBtn?: boolean;
  onHandleClick?: () => void;
  progress?: number;
  iscenteraligned?: boolean;
  customCta?: JSX.Element;
  showBackButton?: boolean;
  handleBack?: () => void;
  hideDescription?: boolean;
  isLoadingConfirmBtn?: boolean;
  customFooter?: React.ReactElement;
}

const Card = (
  {
    children,
    title,
    description = "",
    btnTitle,
    onHandleClick,
    disabledConfirmBtn = false,
    progress,
    iscenteraligned,
    customCta,
    showBackButton,
    handleBack,
    hideDescription,
    isLoadingConfirmBtn,
    customFooter,
  }: CardPropsType,
  ref: Ref<any>
) => {
  return (
    <Box ref={ref}>
      {progress && (
        <LinearProgress variant="determinate" color="info" value={progress} />
      )}
      <CardStyled className="card-wrapper">
        <CardContent>
          <Header
            iscenteraligned={iscenteraligned}
            title={title}
            description={description}
            customCta={customCta}
            showBackButton={showBackButton}
            handleBack={handleBack}
            hideDescription={hideDescription}
          />
          {children && <div className="form-wrapper">{children}</div>}
        </CardContent>
        {!customFooter && onHandleClick && (
          <CardActions>
            <Button
              onClick={onHandleClick}
              disabled={disabledConfirmBtn}
              isLoading={isLoadingConfirmBtn}
            >
              {btnTitle}
            </Button>
          </CardActions>
        )}
        {customFooter && customFooter}
      </CardStyled>
    </Box>
  );
};

export default React.forwardRef(Card);
